export enum TypeCahierCode {
    AOC = 'AOC',
    IGP = 'IGP'
}
